import { Box, Switch, Typography } from "@mui/material";
import { useState } from "react";
import { useIntl } from "react-intl";
import I18nKey from "../../translations/I18nKey";
import ExclamationBlueIcon from "../../assets/Icons/ExclamationBlueIcon.svg";
import SellerFilter from "./shared/components/SellerFilter";

const PromotionalCalendarHeader = () => {
  const [switchChecked, setSwitchChecked] = useState<boolean>(true);

  const intl = useIntl();
  return (
    <Box
      sx={{
        marginTop: "20px",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            color: "#424242",
            fontFamily: "Lato",
          }}
        >
          {intl.formatMessage({
            id: I18nKey.ADVERTISING,
          })}
          :
        </Typography>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 600,
            color: "#424242",
            fontFamily: "Lato",
          }}
        >
          {intl.formatMessage({
            id: I18nKey.PROMOTIONAL_CALENDER,
          })}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "end",
          marginTop: "10px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "start" }}>
          <Box sx={{ margin: "0 12px" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {true ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                      padding: "10px 0",
                      alignItems: "center",
                    }}
                  ></Box>
                ) : null}
                <SellerFilter disableMultiple />

                <Box
                  sx={{
                    padding: "12px",
                    borderRadius: "8px",
                    border: "1px solid #D0D5DD",
                    cursor: "pointer",
                    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    background: "white",
                  }}
                >
                  <img src={ExclamationBlueIcon} alt={"exclamation blue"} />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PromotionalCalendarHeader;
